import React from 'react';
import { Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import ScrollTable from './ScrollTable';


const ObjectiveActivities = (props) => {

    const activities = useSelector(state => state.activities);
    const deliverables = useSelector(state => state.deliverables);
    const departments = useSelector(state => state.departments);

    let activityItems = activities;

    // const departments = [{ 'name': 'Operations', 'slug': 'operations', 'description': 'Proving that our manufacturing process works', 'color': "#6300d6" },
    // { 'name': 'Products', 'slug': 'products', 'description': 'Proving that we have an attractive product', 'color': "#1000d6" },
    // { 'name': 'Sales', 'slug': 'sales', 'description': 'Proving that we can sell and deliver our products', 'color': "#005bd6" },
    // { 'name': 'Bus dev', 'slug': 'business-development', 'description': 'Proving that we have opportunities for scale', 'color': "#00a5d6" },
    // { 'name': 'Finance', 'slug': 'finance', 'description': 'Making sure we have enough money to get it all done', 'color': "#00d6bd" }];


    return (

        <Modal show={props.show} onHide={props.onHide} id="activity-objectives-modal">

            <React.Fragment>
                <Modal.Header closeButton>
                    <Modal.Title>{props.item.name}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-12">
                            <div className="row mb-3">
                                <div className="col-12">
                                    <ScrollTable deliverables={deliverables} departments={departments} item={props.item} />
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>

                </Modal.Footer>
            </React.Fragment>

        </Modal>
    );
}

export default ObjectiveActivities;
